// src/pages/SanJuanTour.jsx
import App from "../App";

export default function SanJuanTour() {
  return <App />;
}
